<script lang="ts">
	import Icon from '../../basic/Icon.svelte';
	import { getColorForString } from '../../helper/Colors';

	interface Props {
		value: string;
		allowDelete?: boolean;
		onClick?: () => void;
		onRequestDelete?: (value: string) => void;
	}

	let { value, allowDelete = false, onClick, onRequestDelete }: Props = $props();
</script>

<button
	onclick={() => onClick?.()}
	style="background-color: {getColorForString(value)};"
	class="fill-white text-white grid grid-cols-[1fr_auto] gap-2 items-center rounded-full py-1 px-3 shadow-md"
>
	<p class="font-bold text-xs truncate">
		{value ? value : ''}
	</p>
	{#if allowDelete}
		<!-- svelte-ignore node_invalid_placement_ssr -->
		<button
			onclick={() => {
				onRequestDelete?.(value);
			}}
		>
			<Icon size="small" name="xmark" />
		</button>
	{/if}
</button>
